'use client';

import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';

import { Flag } from '@zoomit/icons';

import { CookieStorage } from '../../utils/cookie-storage';
import { cn } from '../../utils/cva';
import { useFlagContext } from './flags-provider';

export const FlagsDebugger = () => {
  const { updateFlag, flags } = useFlagContext();
  const [isOpen, setIsOpen] = useState(false);
  const [showFlagsDebugger, setShowFlagsDebugger] = useState(false);

  useEffect(() => {
    const cookies = new CookieStorage();
    setShowFlagsDebugger(cookies.getItem('flags') === 'true');
  }, []);

  if (!showFlagsDebugger) return null;

  return (
    <>
      <div
        data-testid="flag-button"
        onClick={() => setIsOpen(!isOpen)}
        className={cn(
          'fixed right-3 bottom-14 z-99999 cursor-pointer rounded-full p-2 md:bottom-4',
          isOpen ? 'bg-primary1' : 'bg-grey6',
        )}
      >
        <Flag className="fill-white" />
      </div>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ x: '120%' }}
            animate={{ x: 0 }}
            exit={{ x: '120%' }}
            className="bg-card border-grey7 fixed right-3 bottom-24 left-1/2 z-9999 flex max-h-[80vh] flex-col rounded-md border px-4 py-3 shadow-lg md:bottom-14 md:w-96"
          >
            <div className="flex w-full flex-col gap-2 text-right">
              <div dir="rtl" className="flex items-center justify-between">
                <h1 className="text-lg font-bold">فیچر فلگ ها</h1>
              </div>

              <div className="flex max-h-[60vh] flex-col gap-2 overflow-y-auto">
                {Object?.entries(flags)?.map(([key, value]) => (
                  <div
                    className="border-grey3 hover:border-primary1 flex cursor-pointer flex-col rounded-md border p-2 transition-colors"
                    key={key}
                    data-testid={`flag-${key}`}
                    onClick={() => updateFlag(key, !value)}
                  >
                    <div dir="ltr" className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <div
                          data-testid="custom-checkbox"
                          className={cn(
                            'mr-2 h-4 w-4 rounded-sm transition-colors',
                            value ? 'bg-primary1' : 'bg-grey3',
                          )}
                        />
                      </div>
                      <div className="flex items-center">
                        <h2
                          className="text-body max-w-[180px] overflow-hidden text-sm text-ellipsis"
                          title={key}
                        >
                          {key}
                        </h2>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
